<template>
  <v-chip class="pa-5 my-7 mr-2">
    <span class="text-body-2 font-weight-medium">
      <div>
        {{ $i18n.t(translationPath) }}
      </div>
      <div>
        {{ value }}
        <span v-html="unit"></span>
      </div>
    </span>
  </v-chip>
</template>

<script>
export default {
  name: 'NmtSidebarProfileChartDialogChip',
  props: {
    value: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    translationPath: {
      type: String,
      required: true,
    },
    unit: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
